import script from "./Ability.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ability.vue?vue&type=script&lang=ts&setup=true"

import "./Ability.vue?vue&type=style&index=0&id=00ae55b7&lang=scss&scoped=true"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ae55b7"]])

export default __exports__